import { HttpClient } from '@angular/common/http';
import { AppConfig } from 'src/app/app.config';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var PartnerService = /** @class */ (function () {
    function PartnerService(http, config) {
        this.http = http;
        this.config = config;
    }
    PartnerService.prototype.datatable = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/partners/dt", data);
    };
    PartnerService.prototype.manageLink = function (l, action) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/partners/link/" + action, l);
    };
    PartnerService.prototype.updateLegame = function (l) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/partners/link", l);
    };
    PartnerService.prototype.invite = function (body) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/partners/invite", body);
    };
    PartnerService.prototype.getServices = function (id, data) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/partners/service/" + id, data);
    };
    PartnerService.prototype.requestService = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/partners/service/request", data);
    };
    PartnerService.prototype.assignServiceReturnTrip = function (costo, pr, id) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/partners/service/prassign", { costo: costo, pr: pr, id: id });
    };
    PartnerService.prototype.eliminaAlertModificaRequest = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/partners/service/request/alertmodifica/" + id);
    };
    PartnerService.ngInjectableDef = i0.defineInjectable({ factory: function PartnerService_Factory() { return new PartnerService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: PartnerService, providedIn: "root" });
    return PartnerService;
}());
export { PartnerService };
